import { styled } from '@mui/material';
import { QButton, QTypography } from '@kw/quokka-ui';

// error_description the Auth0 login-ip-allowlist Action denies with (cloud-infrastructure quokka-auth0 module).
// Every other Auth0 error keeps the generic "Unable to sign in" screen in app.tsx.
export const LOGIN_NOT_PERMITTED = 'login_not_permitted';

// A plain address rather than the Zendesk link: Zendesk support needs another sign-in, which a denied user may not manage.
export const CUSTOMER_SUPPORT_EMAIL = 'support@quokka.io';

interface SignInDeniedProps {
  readonly onReturnToLogin: () => void;
}

/**
 * Landing state for a login the post-login Action refused. The copy is deliberately generic: it must not confirm
 * that the credentials were valid or hint at why (e.g. the network), so it only points the user at their admin or
 * Support. Support finds the real reason in the Auth0 deny logs.
 */
export default function SignInDenied({ onReturnToLogin }: SignInDeniedProps) {
  return (
    <StyledDiv>
      <QTypography variant="h2Medium" component="h1">
        Unable to sign in
      </QTypography>
      <StyledMessage variant="bodyRegular">
        We couldn&apos;t complete your sign-in to Q-Scout. If you keep seeing this message, contact your organization administrator or
        Quokka customer support at {CUSTOMER_SUPPORT_EMAIL}.
      </StyledMessage>
      <StyledButtonRow>
        <QButton variant="filled" onClick={onReturnToLogin}>
          Return to login page
        </QButton>
        <QButton variant="outlined" href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`}>
          Contact customer support
        </QButton>
      </StyledButtonRow>
    </StyledDiv>
  );
}

const StyledDiv = styled('div')`
  max-width: 720px;
  margin: 48px auto;
  padding: 24px;
  text-align: center;
`;

const StyledMessage = styled(QTypography)`
  display: block;
  margin-top: 16px;
`;

const StyledButtonRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
`;
